import { ReactElement, useMemo } from 'react'
import { Button, Skeleton } from '@raskrask-dk/rr-components'
import { CustomerTypeButtons, Props } from '.'
import { t } from 'i18next'

const CustomerTypeCardsTemplate = ({
    customerType,
    customerTypes,
    isLoading,
    onCustomerTypeClick,
}: Props): ReactElement => {
    const loading = useMemo(
        () => (
            <>
                <Skeleton height={36} width={100} />
                <Skeleton height={36} width={100} />
            </>
        ),
        []
    )

    const customerTypeCards = useMemo(
        () => (
            <>
                {customerTypes.map((type, key) => (
                    <Button
                        active={customerType === type}
                        data-cy={`customerTypeBtn_${key + 1}`}
                        key={key}
                        onClick={() => onCustomerTypeClick(type)}
                        variant="option"
                    >
                        {t(`basistypes.customertypes.${type}`)}
                    </Button>
                ))}
            </>
        ),
        [customerType, customerTypes, onCustomerTypeClick]
    )

    return (
        <CustomerTypeButtons>
            {isLoading ? loading : customerTypeCards}
        </CustomerTypeButtons>
    )
}

export default CustomerTypeCardsTemplate
